export class SearchForm {
    firstName: string;
    lastName: string;
    email: string;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/search-form/search-form.model.ts